import { useState, useEffect } from 'react';
import { UseLoadingStates } from './types.js';

/**
 * Возвращает результат загрузки изображения
 * @param params.src url изображения
 * @return результат загрузки (loading | loaded | error)
 */
function useImageLoadingState({ src }) {
    const [loadingState, setLoadingState] = useState(UseLoadingStates.LOADING);
    useEffect(() => {
        let active = true;
        setLoadingState(UseLoadingStates.LOADING);
        const image = new Image();
        image.onload = function () {
            if (!active) {
                return;
            }
            setLoadingState(UseLoadingStates.LOADED);
        };
        image.onerror = () => {
            if (!active) {
                return;
            }
            setLoadingState(UseLoadingStates.ERROR);
        };
        image.srcset = src;
        return () => {
            active = false;
        };
    }, [src]);
    return loadingState;
}

export { useImageLoadingState };
